import Guard from '@/services/middleware'

const DownloadMessage = () => import('@/views/chat/pages/Download/HomeDownload.vue')
const DownloadMessageError = () => import('@/views/chat/pages/Download/ErrorDownload.vue')

export default [
    {
        path: '/download/file/:type/:id',
        name: 'message.download',
        component: DownloadMessage,
        beforeEnter: Guard.redirectIfNotAuthenticated,
        meta: { title: 'Download de arquivos do chat' },
    },
    {
        path: '/download/file/error',
        name: 'message.download.error',
        component: DownloadMessageError,
        beforeEnter: Guard.redirectIfNotAuthenticated,
        meta: { title: 'Download de arquivos do chat' },
    },
]